export default __webpack_public_path__ + "static/media/upload-img.9062102f.png";